export default __webpack_public_path__ + "static/media/sort-black.5ce31921.svg";